import { z } from 'zod';

export const PlanTypeSchema = z.enum(['MONTHLY', 'QUARTERLY', 'BIANNUAL', 'TRIAL']);
export type PlanType = z.infer<typeof PlanTypeSchema>;

export const PLAN_TITLES: Record<PlanType, string> = {
  TRIAL: 'Trial',
  MONTHLY: 'Monthly Oversight',
  QUARTERLY: 'Quarterly Oversight',
  BIANNUAL: 'Biannual Oversight',
};

export const PLAN_INSPECTIONS_INCLUDED: Record<PlanType, number> = {
  TRIAL: 2,
  MONTHLY: 1,
  QUARTERLY: 3,
  BIANNUAL: 6,
};
export const SubscriptionStatusSchema = z.enum(['ACTIVE', 'EXPIRED', 'STOPPED']);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

export const SubscriptionSchema = z.object({
  subscriptionId: z.string(),
  planTitle: z.string(),
  planType: PlanTypeSchema,
  status: SubscriptionStatusSchema,
  nextInspectionDue: z.string().nullable(),
  autoRenewsOn: z.string().nullable(),
  isAutoRenewalEnabled: z.boolean(),
});
export type Subscription = z.infer<typeof SubscriptionSchema>;

export type CreateSubscriptionRequest = {
  propertyId: string;
  planType: PlanType;
  isAutoRenewalEnabled: boolean;
  price: number;
  currency: string;
  inspectionsIncluded: number;
};

export type UpdateSubscriptionRequest = {
  status?: SubscriptionStatus;
  endDate?: string;
  nextInspectionDue?: string;
  isAutoRenewalEnabled?: boolean;
  inspectionsUsed?: number;
};
